<div class="bg-white overflow-hidden shadow sm:rounded-lg w-96" *ngIf="productSubscriptionData">

  <div class="flex justify-between p-2">
    <div class="flex ml-auto self-end cursor-pointer">
      <button type="button" mat-dialog-close
        class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2"
        (click)="closeDialog()" *ngIf="productSubscriptionData?.dismissable">
        <em class="ti ti-x text-xl font-bold"></em>
      </button>
    </div>
  </div>

  <div class="px-10 pb-8 w-full">
    <div class="text-base flex items-center justify-center">
      <img class="w-30 ml-2" alt="" src="../../../assets/images/png/warning_clock.png" />
    </div>

    <div class="space-y-4 w-full mt-4">
      <p class="font-bold primary-font text-3xl flex justify-center">
        {{productSubscriptionData?.title}}
      </p>

      <p class="primary-font text-gray-500 text-center text-base mt-2">
        {{productSubscriptionData?.message}}
      </p>
    </div>

    <div class="w-full mt-5 flex justify-center">
      <button type="button" (click)="onActionClick()"
        class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700 focus:outline-none">
        {{productSubscriptionData?.action_btn?.text}}
      </button>
    </div>

  </div>
</div>